import { types } from 'mobx-state-tree';
import Actions from './Actions';
import CompanyMetadata from './CompanyMetadata';
import CompanyTopicModel from './CompanyTopicModel/CompanyTopicModel';
import FundingSummary from './FundingSummary';
import RevenueRange from './RevenueRange';
import Views from './Views';
export const CompanyProps = {
    id: types.identifier,
    name: types.optional(types.string, ''),
    hasCompany: types.optional(types.boolean, false),
    city: types.optional(types.string, ''),
    region: types.optional(types.string, ''),
    country: types.optional(types.string, ''),
    country_iso2: types.optional(types.string, ''),
    state: types.optional(types.string, ''),
    min: types.optional(types.integer, 0),
    max: types.optional(types.integer, 0),
    about: types.optional(types.string, ''),
    logoUrl: types.optional(types.string, ''),
    domain: types.optional(types.string, ''),
    homePageUrl: types.optional(types.string, ''),
    founded: types.optional(types.union(types.number, types.string), ''),
    mainIndustry: types.optional(types.string, ''),
    mainIndustryId: types.maybeNull(types.number),
    mainIndustryKey: types.optional(types.string, ''),
    subIndustry: types.optional(types.string, ''),
    facebook: types.optional(types.string, ''),
    twitter: types.optional(types.string, ''),
    LinkedIn: types.optional(types.string, ''),
    isSocial: types.optional(types.boolean, false),
    companyResultString: types.optional(types.string, ''),
    revenueRange: types.optional(RevenueRange, {}),
    companyLid: types.optional(types.maybeNull(types.integer), null),
    isBlockedForShow: types.optional(types.boolean, false),
    topics: types.optional(types.array(CompanyTopicModel), []),
    fundingSummary: types.maybeNull(FundingSummary),
    specialities: types.array(types.optional(types.string, '')),
    listId: types.maybeNull(types.string),
    metadata: types.maybeNull(CompanyMetadata),
};
const Company = types.model(CompanyProps).actions(Actions).views(Views);
export default Company;
